import React from 'react';
import { Box } from 'localmed-core';

import LeafletMap from '../../../../../shared/components/LeafletMap/LeafletMap';

export default function ProfileMap({ offices, activeOffice, ...props }) {
  const markers = offices.map((office) => ({
    id: office.id,
    latitude: office.latitude,
    longitude: office.longitude,
  }));
  const activeMarker = markers.find((marker) => activeOffice && marker.id === activeOffice.id);
  return (
    <Box position="relative" zIndex="0" {...props}>
      <LeafletMap
        markers={markers}
        activeMarker={activeMarker}
        markerSize="sm"
        viewport={
          activeOffice && {
            center: [Number(activeOffice.latitude), Number(activeOffice.longitude)],
            zoom: 10,
          }
        }
        hasZoomControl={false}
        height="100%"
      />
    </Box>
  );
}
